import axios from '../../axios';

export default {
  namespaced: true,

  state: {
    // The villa booking item that Wine is currently being ordered to (created when Client/Guest selects to order wine)
    currentVillaBookingItemId: null,
    currentVillaBookingItem: null,
    villaBookingItem: null,
    // Current Wine order basket items (add/remove from here as client is adding/removing wine items from/to basket)
    currentWineBasketItems: [], // { wineId, name, quantity, lineTotal }
    currentDeliveryChargeThreshold: null,
    currentDeliveryChargeAmount: null,
    filteredWineList: [],
    sortBy: 1,
    temporaryBasket: [],
  },

  getters: {
    getSortBy: (state) => state.sortBy,
    getFilteredWineList: (state) => state.filteredWineList,
    currentVillaBookingItem: (state) => state.currentVillaBookingItem,
    getCurrentVillaBookingItem: (state) => state.villaBookingItem,
    currentWineBasketItems: (state) =>
      state.currentWineBasketItems,
    currentVillaBookingItemId: (state) => {
      if (state.currentVillaBookingItemId) {
        return state.currentVillaBookingItemId;
      } if ($cookies.isKey('current_Wine_Villa_Booking_ItemId')) {
        state.currentVillaBookingItemId = $cookies.get('current_Wine_Villa_Booking_ItemId');
        return state.currentVillaBookingItemId;
      }
      return null;
    },
    currentDeliveryChargeThreshold: (state) => state.currentDeliveryChargeThreshold,
    currentDeliveryChargeAmount: (state) => state.currentDeliveryChargeAmount,
    getTemporaryBasket: (state) => state.temporaryBasket,
  },

  mutations: {
    setSortBy(state, payload) {
      state.sortBy = payload;
    },
    setFilteredWineList(state, payload) {
      state.filteredWineList = payload;
    },
    setCurrentVillaBookingItemId(state, id) {
      if (id) {
        // check if the id is different from the current Villa Booking Item Id then clear basket items
        if (state.currentVillaBookingItemId && state.currentVillaBookingItemId != id) {
          state.currentWineBasketItems = [];
        } else if ($cookies.isKey('current_Wine_Villa_Booking_ItemId') && $cookies.get('current_Wine_Villa_Booking_ItemId') != id) {
          state.currentWineBasketItems = [];
        }

        state.currentVillaBookingItemId = id;
        $cookies.set('current_Wine_Villa_Booking_ItemId', id, '12h', null, null, false); // expire after 12 hours
      } else {
        state.currentVillaBookingItemId = null;
        $cookies.remove('current_Wine_Villa_Booking_ItemId');
      }
    },
    setCurrentVillaBookingItem(state, item) {
      state.currentVillaBookingItem = item;
      state.villaBookingItem = item;
    },
    setCurrentWineBasketItems(state, items) {
      state.currentWineBasketItems = items;
    },
    setCurrentDeliveryChargeThreshold(state, threshold) {
      state.currentDeliveryChargeThreshold = threshold;
    },
    setCurrentDeliveryChargeAmount(state, amount) {
      state.currentDeliveryChargeAmount = amount;
    },
    setTemporaryBasket(state, payload) {
      state.temporaryBasket = payload;
    },
  },

  actions: {

    fetchCurrentVillaBookingItem({ getters, commit }) {
      return new Promise((resolve, reject) => {
        if (getters.currentVillaBookingItem && getters.currentVillaBookingItem.id === getters.currentVillaBookingItemId) {
          // still in state and Id is still the same as the Current Cookie
          commit('setCurrentVillaBookingItem', getters.currentVillaBookingItem);
          resolve(getters.currentVillaBookingItem);
        } else if (getters.currentVillaBookingItemId) {
          const odata = '$select=*&$expand=property';

          // fetch from API and set
          axios.get(`/core/bookingitems/${getters.currentVillaBookingItemId}?${odata}`).then((res) => {
            commit('setCurrentVillaBookingItem', res.data);
            resolve(res.data);
          }).catch((err) => { reject(err); });
        } else {
          commit('setCurrentVillaBookingItem', null);
          reject(null);
        }
      });
    },

    isWineSalesPossible({}, villaBookingItemId) {
      return new Promise((resolve, reject) => {
        if (villaBookingItemId && villaBookingItemId > 0) {
          axios.get(`/core/bookings/wine/isWineSalesPossible/villabookingitemid/${villaBookingItemId}`).then((res) => {
            resolve(res);
          }).catch((err) => { reject(err); });
        } else {
          reject(null);
        }
      });
    },

    getWineProductsByCurrentVillaBookingItemId({ getters, commit }) {
      return new Promise((resolve, reject) => {
        if (getters.currentVillaBookingItemId && getters.currentVillaBookingItemId > 0) {
          axios.get(`/core/wines/villabookingitemid/${getters.currentVillaBookingItemId}`).then((res) => {
            resolve(res);
          }).catch((err) => { reject(err); });
        } else {
          reject(null);
        }
      });
    },

    getWineProductsByBookingItemId({ commit }, bookingItem) {
      commit('setCurrentVillaBookingItem', bookingItem);
      commit('setCurrentVillaBookingItemId', bookingItem.id);
      return new Promise((resolve, reject) => {
        axios.get(`/core/wines/villabookingitemid/${bookingItem.id}`).then((res) => {
          resolve(res);
        }).catch((err) => { reject(err); });
      });
    },

    // item = { wineId, name, quantity, lineTotal, numberofBottles }
    addItemToWineBasket({ state }, item) {
      // check if item by wineId already exists and then just update the quantity and LineTotal
      const wine = state.currentWineBasketItems.length > 0 ? state.currentWineBasketItems.find((w) => w.wineId === item.wineId) : null;
      if (wine) {
        wine.quantity += item.quantity;
        wine.lineTotal += item.lineTotal;
        wine.numberofBottles += item.numberofBottles;
        // wine.winetype = wine.winetype;
      } else {
        state.currentWineBasketItems.push(item);
      }
    },

    // item = { wineId, name, quantity, lineTotal }
    removeItemFromWineBasket({ state }, item) {
      const indexToRemove = state.currentWineBasketItems.findIndex((w) => w.wineId === item.wineId);
      if (indexToRemove > -1) {
        state.currentWineBasketItems.splice(indexToRemove, 1);
      }
    },

    getCurrentDeliveryChargeThreshold({ getters, commit }) {
      return new Promise((resolve, reject) => {
        if (getters.currentVillaBookingItemId && getters.currentVillaBookingItemId > 0) {
          axios.get(`/core/bookings/wine/getdeliverychargethreshold/villabookingitemid/${getters.currentVillaBookingItemId}`).then((res) => {
            commit('setCurrentDeliveryChargeThreshold', res.data.threshold);
            commit('setCurrentDeliveryChargeAmount', res.data.deliveryCharge);
            resolve(res);
          }).catch((err) => {
            commit('setCurrentDeliveryChargeThreshold', null);
            commit('setCurrentDeliveryChargeAmount', null);
            reject(err);
          });
        } else {
          commit('setCurrentDeliveryChargeThreshold', null);
          commit('setCurrentDeliveryChargeAmount', null);
          reject(null);
        }
      });
    },

    // will add the applicable wine charge item to out current wine basket based on bastet items and other confirmed wines to same villa booking item
    applyDeliveryChargeToCurrentWineBasket({ getters, commit }) {
      return new Promise((resolve, reject) => {
        /// check that current villa booking item (ordered to) and wine basket exists
        if (getters.currentVillaBookingItemId && getters.currentVillaBookingItemId > 0 &&
          getters.currentWineBasketItems && getters.currentWineBasketItems.length > 0) {
          axios.post(`/core/bookings/wine/applydeliverycharge/villabookingitemid/${getters.currentVillaBookingItemId}`, getters.currentWineBasketItems).then((res) => {
            commit('setCurrentWineBasketItems', res.data);
            resolve(res);
          }).catch((error) => { reject(error); });
        } else {
          commit('setCurrentWineBasketItems', null);
          reject(null);
        }
      });
    },

    createWineBookingFromCurrentBasket({ getters, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        /// check that current villa booking item (ordered to) and wine basket exists
        if (getters.currentVillaBookingItemId && getters.currentVillaBookingItemId > 0 &&
          getters.currentWineBasketItems && getters.currentWineBasketItems.length > 0) {
          axios.post(`/core/bookings/wine/order/villabookingitemid/${getters.currentVillaBookingItemId}`, getters.currentWineBasketItems).then((res) => {
            // fetch and update current booking (force API call)
            dispatch('bookings/selectBooking', res.data, { root: true }).then(() => {
              resolve(res);
            });
          }).catch((error) => { reject(error); });
        } else {
          commit('setCurrentWineBasketItems', null);
          reject(null);
        }
      });
    },

  },
};
